<template>
	<div class="channel-list">
		<img class="channel-item" :src="channel.qrCodeUrl" v-for="(channel, idx) in channelList" :key="idx" />
	</div>
</template>

<script>
	import ChannelMixin from '../mixins/channelMixin.js';
	export default {
		name: 'ChannelList',
		mixins: [ChannelMixin],
		mounted() {
			this.loadData();
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.channel-list {
		width: 100%;
		overflow-x: auto;
		display:inline;
		white-space: nowrap;
		padding: calc(10px * var(--scale-rate)) 0 env(safe-area-inset-bottom);
		background-color: #FFFFFF;
		.channel-item {
			width: calc(162px * var(--scale-rate));
			height: calc(162px * var(--scale-rate));
			margin-right: calc(52px * var(--scale-rate));
			&:first-child {
				margin-left: calc(134px * var(--scale-rate));
			}
		}
	}
</style>